import { memo, useState } from 'react';
import { Markdown } from './Markdown';
import { motion, AnimatePresence } from 'framer-motion';
import { classNames } from '~/utils/classNames';

interface AssistantMessageProps {
  content: string;
  index: number;
  messagesLength: number;
  reasoningText?: string;
}

export const AssistantMessage = memo(({ content, index, messagesLength, reasoningText }: AssistantMessageProps) => {
  const [isReasoningOpen, setIsReasoningOpen] = useState(false);

  const toggleReasoning = () => {
    setIsReasoningOpen((prev) => !prev);
  };

  return (
    <div className="overflow-hidden w-full text-gray-200">
      {reasoningText && (
        <div className="mb-2">
          <button
            onClick={toggleReasoning}
            className={classNames(
              'flex items-center gap-1.5 px-2 py-1 text-[10px] opacity-90 rounded-md transition-colors',
              'border border-white/10 hover:bg-white/5',
              isReasoningOpen ? 'bg-white/10' : 'bg-transparent',
            )}
          >
            <div className={classNames('transition-transform', isReasoningOpen ? 'rotate-180' : 'rotate-0')}>
              <div className="i-ph:caret-down w-3 h-3" />
            </div>
            <span>{isReasoningOpen ? 'Hide reasoning' : 'Show reasoning'}</span>
          </button>

          <AnimatePresence>
            {isReasoningOpen && (
              <motion.div
                initial={{ height: 0, opacity: 0 }}
                animate={{ height: 'auto', opacity: 1 }}
                exit={{ height: 0, opacity: 0 }}
                transition={{ duration: 0.2 }}
                className="overflow-hidden"
              >
                <div className="mt-2 p-3 border border-white/10 rounded-md bg-white/5 text-xs opacity-90 leading-none">
                  <Markdown html index={index} messagesLength={messagesLength}>
                    {reasoningText}
                  </Markdown>
                </div>
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      )}
      <Markdown html index={index} messagesLength={messagesLength}>
        {content}
      </Markdown>
    </div>
  );
});

